export const personalInfo = {
  name: "Chetan Bhoyar",
  title: "Senior Frontend Developer",
  // subtitle: "React.js · Next.js · React Native · TypeScript",
  location: "India",
  displayLocation: "India",
  email: "cab9722@gmail.com",
  phone: "+91-8412008868",
  profileImage: "https://avatars.githubusercontent.com/u/78400497?v=4",
  resumeUrl: "https://tinyurl.com/34e23de4",
  social: {
    linkedin: "https://www.linkedin.com/in/chetan-bhoyar/",
    github: "https://github.com/chetanbhoyar22",
    twitter: "https://twitter.com/chetanbhoyar22",
    instagram: "https://www.instagram.com/chetan_22_08/",
  },
};

export const summary = `Frontend Developer with 4+ years of experience building scalable web and mobile applications using React.js, Next.js, React Native, and TypeScript. I have contributed to production-ready products across AI, healthcare, agriculture, and enterprise — with a strong focus on clean UI, REST API integration, and state management using Redux. Comfortable working in Agile teams and delivering accessible, performance-focused interfaces from concept to deployment. Open to Senior Frontend and Full-Stack Developer opportunities.`;

export const navLinks = [
  { label: "About", to: "about" },
  { label: "Experience", to: "experience" },
  { label: "Skills", to: "skills" },
  { label: "Projects", to: "projects" },
  { label: "Education", to: "education" },
  { label: "Contact", to: "contact" },
];

export const experienceList = [
  {
    company: "Techify Solutions Pvt. Ltd.",
    location: "Ahmedabad, India",
    role: "React & React Native Developer",
    period: "June 2022 – Present",
    highlights: [
      "Engineered and maintained production-grade web applications using React.js, Next.js, and TypeScript — ensuring scalability, performance, and cross-browser compatibility.",
      "Delivered cross-platform mobile apps with React Native and Expo for iOS and Android, featuring push notifications, real-time sync, and offline-first support.",
      "Architected state management with Redux and Redux-Saga across large-scale modules, improving data flow and long-term maintainability.",
      "Built accessible, responsive UI with Chakra UI — maintaining design consistency across enterprise-level applications.",
      "Integrated 30+ REST APIs and partnered with AI/ML teams to ship chatbot, lead enrichment, and analytics features.",
      "Contributed to diverse product domains including AI SaaS, hospital management, agriculture, and sales automation platforms.",
    ],
  },
  {
    company: "Infopillar Solution",
    location: "Kalyan, Maharashtra",
    role: "Full Stack Development Intern",
    period: "Jan 2022 – Feb 2022",
    highlights: [
      "Developed full-stack web applications using React.js, Node.js, Express.js, and MongoDB.",
      "Built REST APIs and reusable UI components to accelerate feature delivery across modules.",
    ],
  },
  {
    company: "LetsGrowMore",
    location: "Remote, India",
    role: "Web Developer Intern",
    period: "Dec 2021 – Jan 2022",
    highlights: [
      "Created responsive web pages using HTML5, CSS3, JavaScript, and React.js with a mobile-first approach.",
    ],
  },
  {
    company: "The Sparks Foundation",
    location: "Singapore (Remote)",
    role: "Mobile App & Web Development Intern",
    period: "Oct 2021 – Dec 2021",
    highlights: [
      "Implemented React Native mobile features with REST API integration for real-time data handling.",
      "Designed responsive web interfaces focused on clean layout, usability, and cross-device compatibility.",
    ],
  },
  {
    company: "Wisdom Sprouts Technology",
    location: "Pune, Maharashtra",
    role: "MERN Stack Developer Intern",
    period: "Jan 2021 – Jul 2021",
    highlights: [
      "Built a full-stack e-learning platform with authentication, course management, and a complete purchase flow.",
      "Designed MongoDB schemas and developed reusable React components to speed up development across the project.",
    ],
  },
];

export const skillCategories = [
  {
    title: "Core Frontend",
    skills: ["React.js", "Next.js", "TypeScript", "JavaScript (ES6+)", "HTML5", "CSS3 / SCSS"],
  },
  {
    title: "React Ecosystem",
    skills: ["React Hooks", "Context API", "React Router", "Redux", "Redux-Saga", "Redux Toolkit"],
  },
  {
    title: "Mobile",
    skills: ["React Native", "Expo", "Push Notifications", "iOS & Android"],
  },
  {
    title: "UI Frameworks",
    skills: ["Chakra UI", "Tailwind CSS", "Bootstrap", "Material UI", "Ant Design", "Shadcn/UI"],
  },
  {
    title: "Backend & APIs",
    skills: ["Node.js", "Express.js", "REST APIs", "MongoDB", "MySQL"],
  },
  {
    title: "Tools & Practices",
    skills: ["Git", "GitHub", "Figma", "Postman", "Vite", "Webpack", "Agile/Scrum"],
  },
];

export const typingRoles = [
  "Senior Frontend Developer",
  "React.js Developer",
  "React Native Developer",
  "Full Stack Developer",
];

export const stackList = [
  { img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg", name: "React.js", color: "#61DAFB" },
  { img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg", name: "Next.js", color: "#000000" },
  { img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg", name: "TypeScript", color: "#3178C6" },
  { img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg", name: "JavaScript", color: "#F7DF1E" },
  { img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg", name: "HTML5", color: "#E34F26" },
  { img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg", name: "CSS3", color: "#1572B6" },
  { img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg", name: "Tailwind CSS", color: "#06B6D4" },
  { img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg", name: "Bootstrap", color: "#7952B3" },
  { img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg", name: "Redux", color: "#764ABC" },
  { img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg", name: "Node.js", color: "#339933" },
  { img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg", name: "Express.js", color: "#000000" },
  { img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg", name: "MongoDB", color: "#47A248" },
  { img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg", name: "MySQL", color: "#4479A1" },
  { img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg", name: "Java", color: "#ED8B00" },
  { img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg", name: "Git", color: "#F05032" },
  { img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg", name: "GitHub", color: "#181717" },
  { img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg", name: "Figma", color: "#F24E1E" },
  { img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vitejs/vitejs-original.svg", name: "Vite", color: "#646CFF" },
  { img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg", name: "Docker", color: "#2496ED" },
  { img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg", name: "Kubernetes", color: "#326CE5" },
  { img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jenkins/jenkins-original.svg", name: "Jenkins", color: "#D24939" },
  { img: "https://skillicons.dev/icons?i=aws", name: "AWS", color: "#FF9900" },
  { img: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-original.svg", name: "Azure", color: "#0078D4" },
];

export const projectList = [
  {
    img: "https://i.ibb.co/qWSzxxW/React-Blog.png",
    title: "React Blog Application",
    description:
      "A dynamic blog platform built with React Router, enabling smooth navigation across categories and individual posts with a clean, responsive layout.",
    tech_stack: "HTML, CSS, JavaScript & React.js",
    github_url: "https://github.com/chetanbhoyar22/React-Blog-App",
    demo_url: "https://cb-react-blog-app.netlify.app/",
  },
  {
    img: "https://i.ibb.co/q1ZLj1W/REMS.png",
    title: "Real Estate Management System",
    description:
      "A property management application using Java and JDBC to handle listings, sellers, and buyers with a structured, database-driven workflow.",
    tech_stack: "HTML, CSS, Bootstrap, JavaScript, Java & MySQL",
    github_url: "https://github.com/chetanbhoyar22/Real-Estate-Management-System-Application",
    demo_url: "https://chetanbhoyar22.github.io/Real-Estate-Management-System-Application/WebContent/index.html",
  },
  {
    img: "https://i.ibb.co/dB4wr79/Digital-Clock.png",
    title: "Digital Clock",
    description:
      "An interactive clock application with JavaScript-driven logic, real-time updates, and task reminders based on scheduled time intervals.",
    tech_stack: "HTML, CSS & JavaScript",
    github_url: "https://github.com/chetanbhoyar22/Digital-Clock",
    demo_url: "https://chetanbhoyar22.github.io/Digital-Clock/index.html",
  },
  {
    img: "https://i.ibb.co/fSJYqtK/Todo-App-JS.png",
    title: "Todo App",
    description:
      "A responsive task management app built with vanilla JavaScript and DOM APIs — adding, editing, and tracking tasks in real time.",
    tech_stack: "HTML, CSS & JavaScript",
    github_url: "https://github.com/chetanbhoyar22/Todo-App-JS",
    demo_url: "https://chetanbhoyar22.github.io/Todo-App-JS/index.html",
  },
];

export const educationList = [
  {
    degree: "Master of Computer Applications (MCA)",
    institution: "S.G.B.A.U Amravati University, Maharashtra, India",
    period: "2018 – 2021",
  },
  {
    degree: "Bachelor of Commerce — Computer Application (B.Com CA)",
    institution: "R.T.M.N.U Nagpur University, Maharashtra, India",
    period: "2015 – 2018",
  },
];

export const certifications = [
  "Full Stack Web Development — MERN Stack | Wisdom Sprouts, Pune | March 2021",
  "Enterprise Java | January 2021",
];

export const languages = [
  "English — Professional Working Proficiency",
  "Hindi — Full Professional Proficiency",
  "Marathi — Native / Bilingual Proficiency",
];

export const contactText = {
  heading: "Let's build something together",
  subtext:
    "Whether you have a project in mind or an opportunity to discuss, I am always open to connecting. Feel free to reach out — I typically respond within 24 hours.",
};
